import { ofType } from "redux-observable";
import { guard } from "../../../guards/guard";
import { pathEmpty } from "../../../guards/pathEmpty";
import { TypeActionShowMe } from "../../actionShowMe";
import { checkIsResourceToSpendDecoCoupons } from "./checks/checkIsResourceToSpendDecoCoupons";
import { pathSelectDecoCouponBuildingInBuildMenu } from "./paths/pathSelectDecoCouponBuildingInBuildMenu";
export var epicShowMeSpendResource = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShowMe.QuestTaskSpendResource), guard(state$, deps, pathEmpty)([
        checkIsResourceToSpendDecoCoupons(pathSelectDecoCouponBuildingInBuildMenu),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/spend-resource/epicShowMeSpendResource.ts
// module id = 2382
// module chunks = 3